import { styleVariants } from "@vanilla-extract/css";

export const adobeExpressLogo = styleVariants({
  panel: {
    maxWidth: "70%",
  },
  sheet: {
    maxWidth: "30%",
  },
});
